<template>
  <div class="p-4 space-y-4">
    <Card>
      <template #title>Ajouter un Produit</template>
      <template #content>
        <InputText v-model="newItem.name" placeholder="Nom du produit" />
        <InputText v-model="newItem.sku" placeholder="SKU" />
        <InputText v-model="newItem.description" placeholder="Description" />
        <InputNumber v-model="newItem.stock_min" :min="0" placeholder="Stock min" />
        <Button label="Créer" icon="pi pi-plus" @click="createItem" />
      </template>
    </Card>

    <Card>
      <template #title>Liste des Produits</template>
      <DataTable :value="items" stripedRows tableStyle="min-width: 50rem">
        <Column field="id" header="ID" />
        <Column field="name" header="Nom" />
        <Column field="sku" header="SKU" />
        <Column field="stock_min" header="Stock min" />

        <!-- ✅ Correction : slot plutôt que JSX -->
        <Column header="Actions">
          <template #body="slotProps">
            <Button
              icon="pi pi-trash"
              class="p-button-danger"
              @click="deleteItem(slotProps.data.id)"
            />
          </template>
        </Column>
      </DataTable>
    </Card>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { Card } from "primevue/card";
import { Button } from "primevue/button";
import { InputText } from "primevue/inputtext";
import { InputNumber } from "primevue/inputnumber";
import { DataTable } from "primevue/datatable";
import { Column } from "primevue/column";
import { API_URL } from "../settings";

export default {
  components: { Card, Button, InputText, InputNumber, DataTable, Column },
  setup() {
    const items = ref([]);
    const newItem = ref({ name: "", sku: "", description: "", stock_min: 0 });

    const loadItems = async () => {
      const res = await fetch(`${API_URL}api/mc_chat/item`);
      items.value = await res.json();
    };

    const createItem = async () => {
      const res = await fetch(`${API_URL}api/mc_chat/item`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newItem.value)
      });
      if (res.ok) {
        newItem.value = { name: "", sku: "", description: "", stock_min: 0 };
        await loadItems();
      }
    };

    const deleteItem = async (id) => {
      const res = await fetch(`${API_URL}api/mc_chat/item/${id}`, { method: "DELETE" });
      if (res.ok) await loadItems();
    };

    onMounted(loadItems);

    return { items, newItem, createItem, deleteItem };
  }
};
</script>
